import PropTypes from 'prop-types';

import BackgroundLayersControls from './controls/BackgroundLayersControls';
import RasterLayersControls from './controls/RasterLayersControls';
import VectorLayersControls from './controls/VectorLayersControls';

import './style.scss';

const LayersControls = ({mapKey, backgroundLayer, layers}) => {
	return (
		<>
			<VectorLayersControls mapKey={mapKey} />
			<RasterLayersControls layers={layers} />
			<BackgroundLayersControls activeLayerKey={backgroundLayer?.key} />
		</>
	);
};

LayersControls.propTypes = {
	backgroundLayer: PropTypes.object,
	layers: PropTypes.array,
	mapKey: PropTypes.string,
};

export default LayersControls;
